import { makeVar } from '@apollo/client'

import { CartDetails } from 'types/eCommerce/cart'

export const rvECommerceCartData = makeVar({} as CartDetails)

export const rvECommerceIsProcessing = makeVar(true)

export const rvECommerceEmbeddedCheckoutUrl = makeVar<string>('')

export const rvECommerceProcessingAccessoriesIds = makeVar<number[]>([])

export const rvECommerceIsDone = makeVar(false)
